import { AutogenModelEdiReplyCodeQualifiers, AutogenRowEdiReplyCodeQualifiers } from "./autogen/AutogenModelEdiReplyCodeQualifiers";

export class ModelEdiReplyCodeQualifiers extends AutogenModelEdiReplyCodeQualifiers<RowEdiReplyCodeQualifiers> {
	constructor() {
		super(RowEdiReplyCodeQualifiers);
	}
}

export class RowEdiReplyCodeQualifiers extends AutogenRowEdiReplyCodeQualifiers {
}